import { CALYPSO, CALYPSO_LIGHT } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H2, H5 } from 'UIComponents/elements/headings';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import UIFlex from 'UIComponents/layout/UIFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SupportClusterI18nKeys = {
  liveSupport: {
    title: 'interstitial.proPlusSupport.liveSupport.title',
    body: 'interstitial.proPlusSupport.liveSupport.body'
  },
  assistedOnboarding: {
    title: 'interstitial.proPlusSupport.assistedOnboarding.title',
    body: 'interstitial.proPlusSupport.assistedOnboarding.body'
  }
};
const SupportCluster = ({
  iconName,
  i18nKey,
  className
}) => {
  return /*#__PURE__*/_jsxs("div", {
    className: `flex-row ${className}`,
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(UIIconCircle, {
        name: iconName,
        backgroundColor: CALYPSO_LIGHT,
        color: CALYPSO,
        borderWidth: 0,
        size: 36,
        className: "m-right-6",
        style: {
          minWidth: '70px',
          minHeight: '70px',
          padding: '16px'
        }
      })
    }), /*#__PURE__*/_jsxs(UIFlex, {
      direction: "column",
      align: "start",
      children: [/*#__PURE__*/_jsx(H5, {
        className: "m-bottom-1",
        "aria-level": 3,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: SupportClusterI18nKeys[i18nKey].title
        })
      }), /*#__PURE__*/_jsx("p", {
        className: "m-all-0",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: SupportClusterI18nKeys[i18nKey].body
        })
      })]
    })]
  });
};
export const ProPlusSupportContent = () => {
  return /*#__PURE__*/_jsxs("div", {
    className: "flex-column align-center justify-between m-y-15",
    children: [/*#__PURE__*/_jsx(H2, {
      className: "m-bottom-12",
      "aria-level": 2,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "interstitial.proPlusSupport.header"
      })
    }), /*#__PURE__*/_jsxs(UIFlex, {
      direction: "row",
      justify: "between",
      align: "center",
      children: [/*#__PURE__*/_jsx(SupportCluster, {
        iconName: "audioInputOutput",
        i18nKey: "liveSupport",
        className: "m-right-6"
      }), /*#__PURE__*/_jsx(SupportCluster, {
        iconName: "cap",
        i18nKey: "assistedOnboarding",
        className: "m-left-6"
      })]
    })]
  });
};